export default "__VITE_ASSET__DqsT$03R__"